
import { Component, Mixins } from 'vue-property-decorator';
import CommonTargetChart from '@/components/common/CommonTargetChart.vue';
import CommonRankName from '@/components/common/CommonRankName.vue';
import CommonLoading from '@/components/common/CommonLoading.vue';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
import { SingleRankMixin } from '@/utils/mixin';
@Component({
  components: {
    CommonTargetChart,
    CommonRankName,
    CommonRankNumber,
    CommonLoading,
  },
  directives: {
    autoColor: {
      bind(el) {
        const colorMap = new Map([
          ['买入', '#ff2436'],
          ['增持', '#FF661A'],
          ['中性', '#FF9500'],
          ['减持', '#39BC6F'],
          ['卖出', '#07AB4B'],
        ]);
        el.style.color = colorMap.get(el.innerText);
      },
    },
  },
})
export default class SingleGrade extends Mixins(SingleRankMixin) {
  created() {
    this.domIndex = 2;
    this.refName = 'singlegrade';
  }
}
